import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import {
  FaBuilding,
  FaUsers,
  FaClock,
  FaFileInvoiceDollar,
} from "react-icons/fa";

export default function StatsSection({ counts, loading, source }) {
  const stats = [
    {
      value: counts?.permanentCompanyCount || 0,
      suffix: "+",
      title: "Total Companies",
      icon: <FaBuilding />,
    },
    {
      value: counts?.permanentEmployeeCount || 0,
      suffix: "+",
      title: "Total Employees",
      icon: <FaUsers />,
    },
    {
      value: 80,
      suffix: "%",
      title: "HR Admin Time Saved",
      icon: <FaClock />,
    },
    {
      value: counts?.permanentPayslipCount || 0,
      suffix: "+",
      title: "Payslips Generated",
      icon: <FaFileInvoiceDollar />,
    },
  ];
  return (
    <section className="pb-10 px-6 bg-[#d3e0eb]">
      <div className="max-w-6xl mx-auto rounded-md border border-white  shadow-xl p-5">
        {!loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className="flex items-center gap-4 sm:border-r sm:border-white sm:last:border-r-0 sm:pr-4"
              >
                {/* Icon */}
                <div className="w-10 h-10 rounded-md  shadow-md flex items-center justify-center text-[#10324F] text-2xl shrink-0 border border-white">
                  {stat.icon}
                </div>

                {/* Content */}
                <div>
                  <h2 className="text-xl font-bold text-[#10324F] leading-none">
                    <CountUp
                      start={0}
                      end={stat.value}
                      duration={2.5}
                      separator=","
                      suffix={stat.suffix}
                    />
                  </h2>

                  <p className="font-normal text-[#10324F]">{stat.title}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-10 text-[#10324F]">Loading...</div>
        )}
      </div>
      {/* <div
        className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6 text-center bg-transparent pt-6 pb-6 pl-2 pr-2
      rounded-2xl shadow-lg border border-white"
      >
        {!loading ? (
          stats.map((stat, idx) => (
            <div key={idx} className="flex flex-col items-center">
              <p className="tabular-nums min-w-30 text-xl sm:text-2xl font-bold text-[#10324F]">
                <CountUp
                  start={0}
                  end={stat.value}
                  duration={2.5}
                  separator=","
                  suffix={stat.suffix}
                />
              </p>

              <p className="text-[#10324F] text-sm sm:text-base">
                {stat.label}
              </p>
            </div>
          ))
        ) : (
          <p className="col-span-2 sm:col-span-4 text-[#10324F]">Loading...</p>
        )}
      </div> */}
    </section>
  );
}
